import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function EmotionalSection() {
  return <section className="py-16 md:py-24 px-5 md:px-8 bg-[#0B1224] border-y border-[#15203B]" data-id="element-122">
      <div className="max-w-5xl mx-auto" data-id="element-123">
        <div className="flex flex-col md:flex-row-reverse items-center gap-10 md:gap-16" data-id="element-124">
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="md:w-1/2" data-id="element-125">
            <img src="https://cdn.magicpatterns.com/uploads/tEkBWZeDT6ycp1aZZFo7pn/Photorealistic_image,_1_1_square_ratio._202605111448.jpg" alt="Mujer durmiendo en paz" className="w-full h-auto rounded-xl shadow-2xl border border-[#15203B]" width="1024" height="1024" loading="lazy" decoding="async" data-id="element-126" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="md:w-1/2 space-y-6" data-id="element-127">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white leading-tight" data-id="element-128">
              No necesitas ganarle al zumbido. Necesitas dejar de entregarle tu
              noche.
            </h2>

            <div className="w-16 h-1 bg-[#F6C65B] rounded-full" data-id="element-129"></div>

            <div className="text-gray-300 text-lg leading-relaxed space-y-4 pt-4" data-id="element-130">
              <p data-id="element-131">
                Hay una diferencia enorme entre escuchar algo… y sentir que eso
                controla tu descanso.
              </p>
              <p data-id="element-132">
                El Protocolo Silencio TTPM™ no te pide luchar. No te pide
                forzar la mente. No te pide repetir afirmaciones vacías.
              </p>
              <p data-id="element-133">
                Te guía en una secuencia simple para que tu cuerpo baje la
                alerta, tu atención se reubique y tu cerebro empiece a
                clasificar ese sonido como algo menos importante.
              </p>
            </div>

            <blockquote className="border-l-4 border-[#F6C65B] pl-6 py-2 mt-8 italic text-white font-medium text-xl" data-id="element-134">
              "Porque cuando el sonido deja de sentirse como una amenaza… la
              noche cambia."
            </blockquote>
          </motion.div>
        </div>
      </div>
    </section>;
}